import React from 'react';
import { observer } from 'mobx-react';
import { action, extendObservable } from 'mobx';
import BmcMain from '../../bmc_components/Main';
import { camelCase } from '@ridi/object-case-converter';
import Loading from '../Loading';
import { NETWORK_LAYERS } from '../../igmvp_components/models/constants';
import {
  currentVProles,
  bmcPermissions,
  getBmcTaskBoardIdBySection
} from './functions';
import { injectIntl } from 'react-intl';
import TasksMain from '../../board_components/Main';
import { Row } from 'react-bootstrap';
import { inject } from 'mobx-react';
import BlockUi from '../BlockUi'

@injectIntl
@inject('isPremium')
@observer
export default class BmcBoardWrapper extends React.Component {
  constructor(props) {
    super(props);

    extendObservable(this, {
      bmcBoardRootStore: undefined,
      // Check method isUnbundled from BmcKonva on bmc_components/BmcKonva.jsx
      igMvpRootStore: {
        currentLayer: NETWORK_LAYERS.PRODUCT
      }
    });
  }

  state = {
    loading: true,
    permissions: {},
    userRoles: [],

    loadingTasks: true,
    taskId: null,
    taskPermissions: {}
  };

  componentDidMount() {
    this.fetchPermissions();
    this.fetchLayerPermissions();
  }

  componentDidUpdate(prevProps) {
    const {
      match: {
        params: { boardId: currBoardId, layer }
      }
    } = this.props;

    const {
      match: {
        params: { boardId: prevBoardId, layer: prevLayer }
      }
    } = prevProps;

    // fetch permissions whenever board changes
    if (prevBoardId !== currBoardId) {
      this.setState({ loading: true }, this.fetchPermissions);
      if (prevLayer === layer)
        this.setState({ loadingTasks: true }, this.fetchLayerPermissions);
    }

    // Check method isUnbundled from BmcKonva on bmc_components/BmcKonva.jsx
    if (prevLayer !== layer) {
      this.setState({ loadingTasks: true }, this.fetchLayerPermissions);
    }
  }

  @action updateLayer = layer => {
    this.igMvpRootStore.currentLayer = layer || NETWORK_LAYERS.PRODUCT;
  };

  fetchLayerPermissions = async () => {
    const {
      match: {
        params: { boardId, layer }
      }
    } = this.props;

    this.updateLayer(layer);

    if (boardId && layer) {
      const { taskId, permissions: taskPermissions } =
        (await getBmcTaskBoardIdBySection(boardId, layer)) || {};

      return this.setState({ loadingTasks: false, taskId, taskPermissions });
    } else return this.setState({ loadingTasks: false });
  };

  fetchPermissions = async () => {
    const {
      match: {
        params: { boardId }
      }
    } = this.props;

    const [permissions, userRoles] = await Promise.all([
      bmcPermissions(boardId),
      currentVProles()
    ]);

    return this.setState({ loading: false, permissions, userRoles });
  };

  render() {
    const {
      match: {
        params: { boardId }
      },

      userLocale,
      showStages,
      intl
    } = this.props;

    const {
      permissions,
      loading,
      userRoles,
      taskId,
      taskPermissions,
      loadingTasks
    } = this.state;

    if (loading) return <Loading />;

    return (
      <div key={'BMC_Main_div'}>
        <BlockUi blocking={!this.props.isPremium}>
          <div id="bmc-board-container" key={'BMC_Main_container'}>
            <div className="react-bmc-component" key={'BMC_Main_react_component'}>
              <BmcMain
                key={'BMC_Main'}
                bmcId={boardId}
                currentUserPermission={camelCase(permissions)}
                currentUserRoles={userRoles}
                userLocale={intl.locale}
                initRootStore={this.setBmcBoardStore}
                showStages={showStages}
              />
            </div>

            {loadingTasks ? (
              <Loading />
            ) : (
              taskId &&
              taskPermissions && (
                <TasksMain
                  boardId={taskId}
                  currentUserPermission={taskPermissions}
                  currentUserRoles={userRoles}
                  userLocale={intl.locale}
                  boardType={'IgtasksBoard'}
                // initRootStore={this.setBoardStore}
                // bmcUpdate={bmcUpdate}
                />
              )
            )}
          </div>
        </BlockUi>
      </div>
    );
  }

  setBmcBoardStore = bmcBoardRootStore => {
    const { initBoardStore } = this.props;

    if (initBoardStore) initBoardStore(bmcBoardRootStore);

    // Check method isUnbundled from BmcKonva on bmc_components/BmcKonva.jsx
    bmcBoardRootStore.igMvpRootStore = this.igMvpRootStore;
    this.bmcBoardRootStore = bmcBoardRootStore;
  };
}

BmcBoardWrapper.propTypes = {};
